<template>
    <div class="column">
        <h4 class="title is-4">TCO</h4>
        <o-table
                class="is-responsive is-responsive-xs-desktop"
                :data="tco"
                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="table.checkable"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort-direction="table.defaultSortDirection"
                :default-sort="table.defaultSort"

                :selected.sync="selected"
                :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
        >

            <template v-slot:default="{ row }">
                <o-table-column #default="{ row }" field="expirationDate" label="Expiration Date" sortable>
                    {{ row.expirationDate }}
                </o-table-column>

                <o-table-column #default="{ row }" field="company" label="Company" sortable>
                    {{ row.company }}
                </o-table-column>

                <o-table-column #default="{ row }" field="tcoId" label="TCO #" sortable>
                    {{ row.tcoId }}
                </o-table-column>

                <o-table-column #default="{ row }" field="contact" label="Contact" sortable>
                    {{ row.contact }}
                </o-table-column>

                <o-table-column label="">
                    <o-dropdown hoverable position="bottom-left" class="table-actions">
                      <template #trigger>
                        <button class="button">
                          <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                        </button>
                      </template>
                        <o-dropdown-item has-link><a @click="openReminderModal(row.project_id || 1, row.applicant_id || 1)">Set Reminder</a></o-dropdown-item>
                    </o-dropdown>
                </o-table-column>
            </template>

          <template #empty>
            <div class="has-text-centered">
              No Tco Expirations Found
            </div>
          </template>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <send-reminder-modal :project-id="projectId" :contact-id="contactId"/>
        </o-modal>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Table from '../../mixins/Table'
    import SendReminderModal from '../modals/SendReminder'

    export default {
        mixins: [Table],

        components: {
            SendReminderModal
        },

        data () {
            return {
                table: {
                    defaultSort: ['expiration_date', 'asc']
                },
                tco: [
                    {"id": 1, "expirationDate": "02/12/16", "company": "AO + ASSOCIATES, INC", "tcoId": "242", "contact": "designs by human: Joe Human"},
                    {"id": 1, "expirationDate": "02/12/16", "company": "AO + ASSOCIATES, INC", "tcoId": "242", "contact": "designs by human: Joe Human"},
                    {"id": 2, "expirationDate": "04/09/17", "company": "Appel Architecture, DPC", "tcoId": "829", "contact": "W.R. Berkley: Brian Lessard"},
                    {"id": 3, "expirationDate": "07/11/18", "company": "David Obuchowski Architects PLLC", "tcoId": "921", "contact": "Facade Maintenance Design: Rick Lefever"},
                    {"id": 3, "expirationDate": "07/11/18", "company": "David Obuchowski Architects PLLC", "tcoId": "921", "contact": "Facade Maintenance Design: Rick Lefever"},
                ],
                projectId: null,
                contactId: null,
                isReminderModalActive: false
            }
        },

        methods: {
            openReminderModal (projectId, contactId) {
                this.isReminderModalActive = true
                this.projectId = projectId
                this.contactId = contactId
            },
        },

        computed: {
            ...mapGetters({
                dotPermits: 'dotPermits'
            })
        }
    }
</script>
